module.exports = __webpack_public_path__ + "static/media/covid19.1a7b312f.JPG";